import { HotelSearchQueryParams, HotelSearchQueryParamsRoomSlitter, HotelSearchQueryParamsSlitter } from './const';
import { LocationSelection, RoomSelection, SearchData, SearchPropertyData } from './types';

const isValidDate = (dateTime: number) => {
  const date = new Date(dateTime);
  return !isNaN(date.getTime());
};

const parseLocation = (value: string): LocationSelection | null => {
  try {
    const [placeId, latitude, longitude, description] = value.split(HotelSearchQueryParamsSlitter);
    if ((Number(latitude) && Number(longitude) && description && placeId)) {
      return {
        placeId,
        latitude: Number(latitude),
        longitude: Number(longitude),
        description
      };
    }
    return null;
  } catch (e) {
    console.log(e); //TODO: move to sengrid.
    return null;
  }
};

const parseRooms = (value: string): RoomSelection[] | null => {
  try {
    if (!value) return null;
    const rooms = value.split(HotelSearchQueryParamsSlitter).map((roomString) => ({
      paxes: roomString.split(HotelSearchQueryParamsRoomSlitter).map((value) => Number(value))
    }));
    if (
      Boolean(rooms.length) &&
      !rooms.some((room) => !room || !room.paxes.length || room.paxes.some(pax => isNaN(pax)))
    ) {
      return rooms;
    }
    return null;
  } catch (e) {
    console.log(e); //TODO: move to sengrid.
    return null;
  }
};

const parseDate = (value: string): Date | null => {
  try {
    if (value && !isNaN(+value) && isValidDate(+value)) {
      return new Date(+value);
    }
    return null;
  } catch (e) {
    console.log(e); //TODO: move to sengrid.
    return null;
  }

};

export const parseSearchData = (data: URLSearchParams) => {

  const location = parseLocation(data.get(HotelSearchQueryParams.Location) || '');
  const rooms = parseRooms(data.get(HotelSearchQueryParams.Rooms) || '');
  const from = parseDate(data.get(HotelSearchQueryParams.from) || '');
  const to = parseDate(data.get(HotelSearchQueryParams.to) || '');

  return {
    location,
    rooms,
    from,
    to
  };
};

export const appendHotelAvailabilityQueryParamsToUrl = (data: SearchData): URLSearchParams | null => {
  const queryParams = new URLSearchParams();
  const { location, from, to, rooms } = data;

  if (location && from && to && rooms) {
    queryParams.append(
      HotelSearchQueryParams.Location, 
      [location.placeId, location.latitude, location.longitude, location.description].join(HotelSearchQueryParamsSlitter)
    );
    queryParams.append(
      HotelSearchQueryParams.from,
      String(from.getTime())
    );
    queryParams.append(
      HotelSearchQueryParams.to,
      String(to.getTime())
    );
    queryParams.append(
      HotelSearchQueryParams.Rooms,
      rooms.map(({paxes}) => paxes.join(HotelSearchQueryParamsRoomSlitter)).join(HotelSearchQueryParamsSlitter)
    );

    return queryParams;
  }

  return null;
};

export const appendHotelPropertyQueryParamsToUrl = (data: SearchPropertyData): URLSearchParams | null => {
  const queryParams = new URLSearchParams();
  const { property, from, to, rooms } = data;

  if (property && from && to && rooms) {
    queryParams.append(
      HotelSearchQueryParams.Property, 
      property.nimbuxHotelId
    );
    queryParams.append(
      HotelSearchQueryParams.from,
      String(from.getTime())
    );
    queryParams.append(
      HotelSearchQueryParams.to,
      String(to.getTime())
    );
    queryParams.append(
      HotelSearchQueryParams.Rooms,
      rooms.map(({paxes}) => paxes.join(HotelSearchQueryParamsRoomSlitter)).join(HotelSearchQueryParamsSlitter)
    );
    queryParams.append('doSearch', 'true');

    return queryParams;
  }

  return null;
};
